import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Frame } from 'framer';
import { motion } from "framer-motion"

const Animation = props => {
    const {
        animation
    } = props;
    useEffect(() => {

    }, [])

    // const spring = {
    //     type: "spring",
    //     damping: 10,
    //     stiffness: 100,
    //     duration: 0.5
    // }
    const spring = {
        type: "spring",
        damping: 50,
        stiffness: 100,
        duration: 0.2
    }
    const drop = {
        type: "spring",
        damping: 10,
        stiffness: 100,
        duration: 1
    }

    // Frame
    if(animation === 'moveDown'){
        return (
            <Frame size='100%' position="relative" background='transparent' style={{flexGrow: 4}}
                transition={spring} 
                initial={{ y: -25 }}
                animate={{ y: 0 }}
                positionTransition>
                    {props.children}
            </Frame>
        )
    } else if (animation === 'moveUp'){
        return (
            <Frame size='100%' position="relative" background='transparent' style={{flexGrow: 4}}
                transition={spring} 
                initial={{ y: 25 }}
                animate={{ y: 0 }}
                positionTransition>
                    {props.children}
            </Frame>
        )
    } else if (animation === 'drop'){
        return (
            <Frame size='100%' position="relative" background='transparent' style={{flexGrow: 4}}
                transition={drop} 
                initial={{ scale: 1.1, opacity: 0.5 }}
                animate={{ scale: 1 , opacity: 1}}
                positionTransition>
                    {props.children}
            </Frame>
        )
    } else {
        return (
            <div style={{ width: '100%'}}>{props.children}</div>
        )
    }

    // Motion DIV
    // if(animation === 'moveDown'){
    //     return (
    //         <Frame size='100%' position="relative" background='transparent'
    //             transition={spring} 
    //             initial={{ y: -25 }}
    //             animate={{ y: 0 }}
    //             dragElastic={1}
    //             drag="y"
    //             positionTransition>
    //                 {props.children}
    //         </Frame>
    //     )
    // } else if (animation === 'moveUp'){
    //     return (
    //         <motion.div size='100%' position="relative" background='transparent'
    //             transition={spring} 
    //             initial={{ y: 25 }}
    //             animate={{ y: 0 }}
    //             dragElastic={1}
    //             drag="y"
    //             positionTransition>
    //                 {props.children}
    //         </motion.div>
    //     )
    // } else if (animation === 'drop'){
    //     return (
    //         <motion.div size='100%' position="relative" background='transparent'
    //             transition={drop} 
    //             initial={{ scale: 1.1, opacity: 0.5 }}
    //             animate={{ scale: 1 , opacity: 1}}
    //             positionTransition>
    //                 {props.children}
    //         </motion.div>
    //     )
    // } else {
    //     return (
    //         <div>{props.children}</div>
    //     )
    // }
}

export default Animation;